import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Multiselect from 'components/Multiselect';
import {Panel} from 'react-bootstrap';
import {CustomDateRange} from 'components/date-range/index';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import { Dropdown } from '../../components/Dropdown/Dropdown';
import Translate from 'components/translate';

class SubcontractorWorkOrdersFilter extends Component {
  static propTypes = {
    ProjectSelectList: PropTypes.array,
    onFetchProject: PropTypes.func,
    onFilter: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {
      isLoadingProject: false,
      panelToggle: false,
      ProjectIds: [],
      Statuses: [],
      WOStatusValue: [
        { key: 1, value: 'Open' },
        { key: 4, value: 'Resolved' },
        { key: 5, value: 'Closed' }
      ]
    };
  }

  onSelectMultiSelect = type => value => {
    this.setState({
      [type]: value
    }, () => {
      this.props.onFilter(this.mapParams());
    });
  }

  onSaveDateRange = type => (fromDate, toDate) => {
    if (fromDate && toDate) {
      this.setState({
        [type]: {from: fromDate, to: toDate}
      }, () => {
        this.props.onFilter(this.mapParams());
      });
    } else {
      this.setState({
        [type]: null
      }, () => {
        this.props.onFilter(this.mapParams());
      });
    }
  }

  onChangeDueDateSelect = (event, name) => {
    if (event && event.value) {
      this.setState({
        [name]: event.value,
        dueDate: {
          dueStatus: 1,
          datetime: formatTimezoneDateTime(moment(), false)
        }
      }, () => {
        this.props.onFilter(this.mapParams());
      });
    } else {
      this.setState({
        [name]: null,
        dueDate: {
          dueStatus: '',
          datetime: ''
        }
      }, () => {
        this.props.onFilter(this.mapParams());
      });
    }
  }

  mapParams = () => {
    const projectIds = [];
    if (this.state.ProjectIds.length > 0) {this.state.ProjectIds.map(e => {projectIds.push(e.value);});}
    const statuses = [];
    if (this.state.Statuses.length > 0) {this.state.Statuses.map(e => {statuses.push(e.value);});}

    let params = {};
    projectIds.length ? params['ProjectIds'] = projectIds.toString() : params['ProjectIds'] = '';
    statuses.length ? params['Statuses'] = statuses.toString() : params['Statuses'] = '';
    params.skip = 0;
    if (this.state.sentDate) {
      params['SentDateFrom'] = this.state.sentDate.from;
      params['SentDateTo'] = this.state.sentDate.to;
    } else {
      params['SentDateFrom'] = '';
      params['SentDateTo'] = '';
    }

    if (this.state.appointmentDate) {
      params['AppointmentDateFrom'] = this.state.appointmentDate.from;
      params['AppointmentDateTo'] = this.state.appointmentDate.to;
    } else {
      params['AppointmentDateFrom'] = '';
      params['AppointmentDateTo'] = '';
    }

    if (this.state.resolvedDate) {
      params['ResolvedDateFrom'] = this.state.resolvedDate.from;
      params['ResolvedDateTo'] = this.state.resolvedDate.to;
    } else {
      params['ResolvedDateFrom'] = '';
      params['ResolvedDateTo'] = '';
    }

    if (this.state.closedDate) {
      params['ClosedDateFrom'] = this.state.closedDate.from;
      params['ClosedDateTo'] = this.state.closedDate.to;
    } else {
      params['ClosedDateFrom'] = '';
      params['ClosedDateTo'] = '';
    }

    if (this.state.dueDate) {
      params['dueStatus'] = this.state.dueDate.dueStatus;
      params['datetime'] = this.state.dueDate.datetime;
    } else {
      params['dueStatus'] = '';
      params['datetime'] = '';
    }

    return params;
  }

  toggleLoading = type => () => {
    this.setState({[type]: !this.state[type]});
  }

  onFetchProject = () => {
    this.setState({
      isLoadingProject: true
    }, () => {
      this.props.onFetchProject(this.toggleLoading('isLoadingProject'));
    });
  }

  render() {
    return (
      <div className='clearfix sub-work-orders-fillter'>
        <Panel expanded={this.state.panelToggle}>
          <Panel.Heading >
            <Panel.Title onClick={() => { this.setState({panelToggle: !this.state.panelToggle});}}>
                Filters
              {!this.state.panelToggle
                ? <span><i className='fa fa-angle-double-down' /></span>
                : <span><i className='fa fa-angle-double-up' /></span>
              }
            </Panel.Title>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body>
              <div className='row lot-filter-wrapper' style={{marginBottom: 0}}>
                <div className='col-sm-12' style={{padding: 0, marginTop: -5}}>
                  <div className='col-sm-3 lot-filter-block'>
                    <label className='col-sm-12 control-label'>Status</label>
                    <div className='col-sm-12 control-label'>
                      <Multiselect
                        placeholder='Any'
                        items={this.state.WOStatusValue.map(item => ({label: item.value, value: item.key}))}
                        value={this.state.Statuses}
                        onChange={this.onSelectMultiSelect('Statuses')}
                        ref={ref => {
                          this.Statuses = ref;
                        }}
                      />
                    </div>
                  </div>
                  <div className='col-sm-3 lot-filter-block'>
                    <label className='col-sm-12 control-label'><Translate translateKey='project' plurals capitalize /></label>
                    <div className='col-sm-12 control-label'>
                      <Multiselect
                        placeholder='Any'
                        items={this.props.ProjectSelectList.map(item => ({label: item.text, value: item.value}))}
                        value={this.state.ProjectIds}
                        onChange={this.onSelectMultiSelect('ProjectIds')}
                        onRemote={this.onFetchProject}
                        isLoading={this.state.isLoadingProject}
                        ref={ref => {
                          this.ProjectIds = ref;
                        }}
                      />
                    </div>
                  </div>
                  <div className='col-sm-2 lot-filter-block'>
                    <label className='col-sm-12 control-label'>Sent date</label>
                    <div className='col-sm-12 control-label'>
                      <CustomDateRange
                        onSave={this.onSaveDateRange('sentDate')} />
                    </div>
                  </div>
                  <div className='col-sm-2 lot-filter-block'>
                    <label className='col-sm-12 control-label'>Appointment date</label>
                    <div className='col-sm-12 control-label'>
                      <CustomDateRange
                        onSave={this.onSaveDateRange('appointmentDate')} />
                    </div>
                  </div>
                  <div className='col-sm-2 lot-filter-block'>
                    <label className='col-sm-12 control-label'>Resolved date</label>
                    <div className='col-sm-12 control-label'>
                      <CustomDateRange
                        onSave={this.onSaveDateRange('resolvedDate')} />
                    </div>
                  </div>
                </div>
                <div className='col-sm-12' style={{padding: 0, marginTop: -5}}>
                  <div className='col-sm-2 lot-filter-block'>
                    <label className='col-sm-12 control-label'>Closed date</label>
                    <div className='col-sm-12 control-label'>
                      <CustomDateRange
                        onSave={this.onSaveDateRange('closedDate')} />
                    </div>
                  </div>
                  <div className='col-sm-2 lot-filter-block'>
                    <label className='control-label'>Due status</label>
                    <div className='control-label'>
                      <Dropdown
                        onChange={ref => { this.onChangeDueDateSelect(ref, 'dueDateSelect'); }}
                        className='filestring-dropdown filter-dropdown'
                        options={[{text: 'Overdue', value: 'overdue'}]}
                        optionLabel='text'
                        value={this.state.dueDateSelect}
                        showClear={true}
                        name='dueDateSelect'
                        placeholder='Any'
                        style={{ width: '100%', position: 'relative' }} />
                    </div>
                  </div>
                </div>
              </div>

            </Panel.Body>
          </Panel.Collapse>
        </Panel>
      </div>
    );
  }
}

export default SubcontractorWorkOrdersFilter;




// WEBPACK FOOTER //
// ./src/Work-Orders/Components/SubcontractorWorkOrdersFilters.js